



























import { VNode } from 'vue';
import { Component, Prop, Model } from 'vue-property-decorator';
import { SwExtendedVue } from '../sw-extended-vue';
import { SwIconButton } from '../sw-icon-button';
import { SwCheckbox } from '../sw-checkbox';
import { dropdown, DropdownDirValues, SwDropdownUnit } from '../dropdown-dir';

import { TableColumnConfig } from './types';

const cssPrefix = 'sw-table-column-selection';

/**
 * @event change `(selectedKeys: string[])`
 */
@Component({
  components: {
    SwIconButton,
  },
  directives: {
    dropdown,
  },
})
export default class SwTableColumnSelection extends SwExtendedVue {
  @Prop({ type: Array, required: true })
  columns: TableColumnConfig[];

  @Prop({ type: Number, default: 700 })
  maxHeight: number;

  @Prop({ type: Number, default: 700 })
  maxWidth: number;

  @Model('change', { type: Array, required: true })
  selectedColumnKeys: string[];

  /** only effective when no slot is provided */
  @Prop({ type: String, default: 'Columns' })
  label: string;

  cssPrefix = cssPrefix;
  selectionVisible: boolean = false;

  get dropdownValues(): DropdownDirValues {
    return {
      placement: 'bottom',
      visible: this.selectionVisible,
      // reverting the unlimited height change.. have kept the @Prop for later reconsideration...
      // maxHeight:this.maxHeight ? this.maxHeight : 1000,
      // maxWidth:this.maxWidth ? this.maxWidth : 700,
      content: (h): VNode[] => { // tslint:disable-line
        const nodes: VNode[] = [];

        this.columns.forEach((col) => {
          nodes.push(
            <SwDropdownUnit nativeOn-click={() => { this.onClickOption(col); }}>
              <SwCheckbox
                {...{ class: 'sw-flexbox__flex-none' }}
                props-theme="dark"
                props-name={`col-opt-${col.key}`}
                props-checked={this.selectedColumnKeys.includes(col.key)}
              />
              <span class={[`${this.cssPrefix}__col-title`]}>{ col.title }</span>
            </SwDropdownUnit> as VNode,
          );
        });

        return nodes;
      },
      onClickOutsidePopper: () => {
        this.selectionVisible = false;
      },
    };
  }

  private onClickTrigger() {
    this.selectionVisible = !this.selectionVisible;
  }

  private onClickOption(col: TableColumnConfig) {
    const resultKeys = this.selectedColumnKeys.slice(0);
    const index = resultKeys.indexOf(col.key);

    if (index >= 0) {
      resultKeys.splice(index, 1);
    } else {
      resultKeys.push(col.key);
    }

    this.$emit('change', resultKeys);
  }
}
